import moment from 'moment';

export const PLAN_NAMING_MESSAGES = {
    jobRequired: 'Job Name required, please enter a job name.',
    floorRequired: 'Floor level required, please enter a floor level.',
    jobAndFloorRequired: 'A Job Name and Floor Name for all Plans.',
};

export const DEFAULT_NEW_PLAN_NAME_FORMAT = 'YY-MM-D_h:mm:ssa';

/** Default plan name stamped at submit time, not when the upload form mounts. */
export function defaultNewPlanFileName(now = moment()) {
    return `NewPlan_${moment(now).format(DEFAULT_NEW_PLAN_NAME_FORMAT)}`;
}

export function normalizePlanNameSegment(value) {
    if (value == null || value === '') {
        return '';
    }
    return value.includes('_') ? value : `${value}_`;
}

export function buildPlanFileName({ jobName = '', floorName = '', areaName = '', extension = '' }) {
    const job = normalizePlanNameSegment(jobName);
    const floor = normalizePlanNameSegment(floorName);
    const area = normalizePlanNameSegment(areaName);
    if (!job && !floor && !area) {
        return '';
    }
    return `${job}${floor}${area}BM${extension}`;
}

/** @returns {{ ok: true } | { ok: false, message: string }} */
export function validatePlanNaming({ jobName, floorName }) {
    if (jobName === '') {
        return { ok: false, message: PLAN_NAMING_MESSAGES.jobRequired };
    }
    if (floorName === '') {
        return { ok: false, message: PLAN_NAMING_MESSAGES.floorRequired };
    }
    return { ok: true };
}

export function canProceedWithPlanNaming({ jobName, floorName }) {
    return validatePlanNaming({ jobName, floorName }).ok;
}
